import React from 'react';

export function Home() {
    return (
        <div className="p-4">
            <h1 className="mx-auto text-center text-info">Scott Helm <span className="text-muted">Development</span></h1>
            <p className="my-4">
                Welcome to my portfolio! My name is Scott Helm and I am a software developer currently based out of Hamilton, Ontario.
                My goal for this website is to discuss my work experience, to showcase projects I enjoyed working on at college, 
                and to give background on myself both professionally and personally.
            </p>
            <p>This site is built using:</p>
            <ul>
                <li key="home-react">
                    <a href="https://facebook.github.io/react/" target="_blank" className="link-dark" rel="noopener noreferrer">React</a> for client-side code
                </li>
                <li key="home-bootstrap">
                    <a href="http://getbootstrap.com/" target="_blank" className="link-dark" rel="noopener noreferrer">Bootstrap</a> for layout and styling
                </li>
                <li key="home-digitalocean">
                    <a href="https://www.digitalocean.com/" target="_blank" className="link-dark" rel="noopener noreferrer">DigitalOcean</a> for web hosting
                </li>
            </ul>
            <p className="my-4">You can find my github repository <a href="https://github.com/KQuinnDevelopment" className="link-dark" target="_blank" rel="noopener noreferrer">here!</a></p>
            <p>
                This is a website that I built myself by hand, keeping it clean and simple with what I hope is a hint of personal flair.
                Thank you for taking the time to look it over and for considering me as a potential hire.
            </p>
            <p>My name may appear differently throughout the site, as I had thought about changing it during college.</p>
        </div>
    );
}